// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-index-js": () => import("/Users/ferbueno/workspace/tecnipres/gatsby-tecnipres/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/Users/ferbueno/workspace/tecnipres/gatsby-tecnipres/.cache/data.json")

